import { bets } from '@/socket'
import { mapState, mapActions } from 'vuex'

export default {
  mounted () {
    bets.on('new-bet', (data) => {
    	data = JSON.parse(data)
    	this.setBetInfo({
    		event: 'new-bet',
    		data: data
    	})
    })
  },

  methods: {
  	...mapActions('meta', ['setBetInfo'])
  }
}
